






import { Component, Vue } from "vue-property-decorator";
import { getFeedback, Entry } from "../api";
import { namespace } from "vuex-class";

import FeedbackTable from "../components/FeedbackTable.vue";

const snackStore = namespace("snackbar");

@Component({
  components: { FeedbackTable }
})
export default class Feedback extends Vue {
  @snackStore.Mutation defaultError!: () => void;

  feedback: Entry[] = [];

  async loadFeedback() {
    try {
      this.feedback = await getFeedback();
    } catch (e) {
      this.defaultError();
    }
  }

  mounted() {
    this.loadFeedback();
  }
}
